import React, { Component, MouseEvent, ChangeEvent } from 'react'
import * as grpcWeb from 'grpc-web';
import { Image as ImagePb } from '../../rpc/admin/image_pb';
import { UploadProductImageRequest } from '../../rpc/admin/products_pb';
import Notification from '../notification';
import { AdminServiceClient } from '../../rpc/admin/AdminServiceClientPb';
import { getBaseApiUrl, getInstance, Instance } from '../../helpers/instance';
import { getAuthMetadata, convertErrorMessage } from '../../helpers/rpc';
import { logOut } from '../../helpers/login';
import ImageList from './image_list';

interface ImagesProps {
    values: Array<ImagePb>;
    disabled?: boolean;
    onChange?: (values: Array<ImagePb>) => void;
}

interface ImagesState {
    open: boolean;
    imagePreviewUrl: string | ArrayBuffer | null;
    imageArray: Uint8Array | null;
    errorMessage: string;
    loading: boolean;
}

class Images extends Component<ImagesProps, ImagesState> {

    constructor(props: ImagesProps) {
        super(props);
        this.state = {
            open: false,
            imagePreviewUrl: null,
            imageArray: null,
            errorMessage: '',
            loading: false
        };
    }

    private handleReorder = (values: Array<ImagePb>) => {
        if (this.props.onChange) {
            this.props.onChange(values);
        }
    }

    private handleKeyDown = (e: KeyboardEvent): any => {
        if (e.key === 'Escape') {
            this.cancel();
        } else if (e.key === 'Enter') {
            this.ok();
        }
    }

    private handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
    
        const urlReader = new FileReader();
        const file = e.target.files![0];
    
        urlReader.onloadend = () => {
          this.setState({
            imagePreviewUrl: urlReader.result,
          });
        }
        urlReader.readAsDataURL(file);

        var arrayReader = new FileReader();
        arrayReader.onload = () => {
            this.setState({
              imageArray: new Uint8Array(arrayReader.result as ArrayBuffer)
            });

        }
        arrayReader.readAsArrayBuffer(file);
    }

    private handleUploadClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        if (!this.state.open) {
            window.addEventListener('keydown', this.handleKeyDown);
            this.setState({
                open: true,
                imagePreviewUrl: null,
                imageArray: null,
                errorMessage: ''
            });
        }
    }

    private handleOkClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        this.ok();
    }

    private handleCancelClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        this.cancel();
    }

    private ok = () => {
        if (!this.state.imageArray) {
            this.setState({
                errorMessage: 'Select a file to continue'
            });
            return;
        }

        this.setState({
            loading: true
        });

        const client = new AdminServiceClient(getBaseApiUrl(), null, null);
        const request = new UploadProductImageRequest();
        request.setImage(this.state.imageArray);
        client.uploadProductImage(request, getAuthMetadata(), (err: grpcWeb.Error, response: ImagePb) => {
            this.setState({
                loading: false
            });
            if (!err) {
                window.removeEventListener('keydown', this.handleKeyDown);
                this.setState({
                    open: false,
                    imagePreviewUrl: null,
                    imageArray: null,
                    errorMessage: ''
                });
                // TODO: check if this image is already in the list and prevent dupes
                if (this.props.onChange) {
                    const values = this.props.values;
                    values.push(response);
                    this.props.onChange(values);
                }
            } else {
                if (err.code === grpcWeb.StatusCode.UNAUTHENTICATED || err.code === grpcWeb.StatusCode.PERMISSION_DENIED) {
                    logOut();
                } else {
                    this.setState({
                        errorMessage: convertErrorMessage(err),
                    });
                    console.error(err);
                }
            }
        });
    }

    private cancel = () => {
        window.removeEventListener('keydown', this.handleKeyDown);
        this.setState({
            open: false
        });
    }

    static imageUrl(path: string): string {
        if (getInstance() === Instance.InstanceLocal) {
            return 'https://dashboard.hawkamerican.dev/' + path;
        }
        return '/' + path;
    }

    static thumbnailUrl(path: string): string {
        path = path.replace('/originals/', '/128x128/');
        if (getInstance() === Instance.InstanceLocal) {
            return 'https://dashboard.hawkamerican.dev/' + path;
        }
        return '/' + path;
    }

    render() {
        return (
            <>
                <label className="label">Images</label>
                <ImageList images={this.props.values} disabled={this.props.disabled} onChange={this.handleReorder} />
                <button className="button is-link is-small" onClick={this.handleUploadClick}>Upload Image</button>
                {
                    this.state.open && (
                        <div className="modal is-active">
                            <div className="modal-background"></div>
                                <div className="image-modal">
                                    <Notification className="image-notification" message={this.state.errorMessage} />
                                    <div className="image-modal-container">
                                        { this.state.imagePreviewUrl &&
                                            <img src={this.state.imagePreviewUrl as string} alt="" />
                                        }
                                        { !this.state.imagePreviewUrl &&
                                            <label className="button is-link">
                                                Select Image...
                                                <input type="file" onChange={this.handleFileChange} />
                                            </label>
                                        }
                                    </div>
                                    <div className="image-modal-controls">
                                        <button className={"button is-success" + (this.state.loading ? " is-loading" : "")}
                                            onClick={this.handleOkClick}
                                            disabled={this.state.loading}>OK</button>
                                        <button className="button" onClick={this.handleCancelClick} disabled={this.state.loading}>Cancel</button>
                                    </div>
                                </div>
                        </div>
                    )
                }
            </>
        );
    }
}

export default Images;
